import { createFileRoute } from "@tanstack/react-router";
import { HomePage, homeHead } from "@/pages/HomePage";

export const Route = createFileRoute("/en/")({
  head: () => homeHead("en"),
  component: () => <HomePage locale="en" />,
});
